// src/realtime/usePGBroadcastStatus.ts
import * as React from "react";
import { getPGBroadcastClient } from "./pgbroadcastSingleton";
import type { PGBroadcastStatus } from "./pgbroadcast";

export function usePGBroadcastStatus(): PGBroadcastStatus {
  const [status, setStatus] = React.useState<PGBroadcastStatus>(() =>
    getPGBroadcastClient().getStatus(),
  );

  React.useEffect(() => {
    const c = getPGBroadcastClient();
    return c.onStatus(setStatus);
  }, []);

  return status;
}
